var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:({ backgroundColor: ("#" + _vm.backgroundColor), '--size': (_vm.size + "px"), '--font-size': (_vm.fontSize + "rem") })},[_c('span',{style:({ color: _vm.textColor })},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []

export { render, staticRenderFns }